import React from "react";
import { RectBadge } from "../../../../common";
import './BeginChallengeDashboardHeader.scss';

// isHeaderSticky triggers the compact sticky-mode layout: a separate
// circular back button floating to the left, and a narrower pill (just
// the date) to the right - two distinct elements with a gap between them,
// not merged into one bar. onBackClick needs to be passed by the caller
// (e.g. history.goBack()).
const BeginChallengeDashboardHeader = ({ badgeClassname, date, showBackButton, onBackClick }) => {
    return (
        <div className={`begin-team-dashboard-header-row`}>
            {showBackButton && (
                <button
                    type="button"
                    className="begin-team-dashboard-back-button"
                    onClick={onBackClick}
                    aria-label="Back"
                >
                    <img src="/images/challenge/arrow-black.svg" alt="" />
                </button>
            )}
            <div className="begin-team-dashboard-badge-row">
                {!showBackButton && badgeClassname && (
                    <RectBadge badgeClassname={badgeClassname}>
                        <div className="rect-badge-title">{badgeClassname?.title}</div>
                    </RectBadge>
                )}
                {date && (
                    <div className="begin-team-dashboard-date">{date}</div>
                )}
            </div>
        </div>
    )
}

export default BeginChallengeDashboardHeader;